import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.slice.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import sortBy from 'lodash/sortBy';
/**
 * Construct a SummaryBuilder instance, which may generate lines of question summary content for
 * use on e.g. the Share page.
 *
 * @param {Object} payload
 * @param {Boolean} payload.compact Whether a compact summary should be generated or not.
 * @returns {Object}
 */

export default (function (_ref) {
  var compact = _ref.compact;
  var weight = 50;
  var lines = [];

  var add = function add(v) {
    return lines.push(_objectSpread(_objectSpread({}, v), {}, {
      weight: weight
    }));
  };

  return {
    compact: compact,
    setWeight: function setWeight(w) {
      return weight = w;
    },
    rating: function rating(text) {
      return add({
        type: 'rating',
        text: text,
        value: 0
      });
    },
    emoji: function emoji(text, value) {
      return add({
        type: 'emoji',
        text: text,
        value: value || null
      });
    },
    service: function service(text, value) {
      return add({
        type: 'rating',
        text: text,
        value: value
      });
    },
    avatar: function avatar(text, _avatar) {
      return add({
        type: 'avatar',
        avatar: [_avatar],
        value: '',
        text: text
      });
    },
    grade: function grade(text, value) {
      return add({
        type: 'grade',
        text: text,
        value: value
      });
    },
    comments: function comments(text) {
      return add({
        type: 'comments',
        text: text
      });
    },
    build: function build() {
      // Take a shallow copy that we can modify and build upon
      var built = [].concat(lines); // Order by descending weight

      built = sortBy(built, function (b) {
        return -b.weight;
      }); // If in compact mode, don't render any text

      if (compact) {
        built = built.map(function (o) {
          return _objectSpread(_objectSpread({}, o), {}, {
            text: null
          });
        });
      } // Summarise, by only shipping the top N items by weight.
      // In compact mode, we set that to 4 to aim for a single line of items.


      var limit = compact ? 4 : 5;
      return built.slice(0, limit);
    }
  };
});